import React, {ReactNode, useEffect, useState} from 'react';
import SpaceBetween from "../common/SpaceBetween"
import {Box, IconButton, SxProps, Typography} from "@mui/material"
import ShuffleIcon from "@mui/icons-material/Shuffle"
import InfoAlert from "../alert/InfoAlert"
import ErrorMessage from "../error/ErrorMessage"
import {RowRequests} from "../../api/requests/RowRequests"
import RowJson from "../../api/json/RowJson"
import ApiError from "../../api/ApiError"
import {ProjectJson} from "../../api/json/ProjectJson"

interface ExamplePreviewProps {
    project: ProjectJson
    row?: RowJson
    children: ReactNode
    handleExample: (row: RowJson) => void
    sx?: SxProps
}

function RandomRowLoader({project, row, children, handleExample, sx}: ExamplePreviewProps) {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<ApiError>()

    const loadExample = () => {
        if (loading) return

        setLoading(true)
        RowRequests.getRandom(project.id, 1)
            .then(page => {
                handleExample(page.content[0])
                setError(undefined)
            })
            .catch(setError)
            .finally(() => setLoading(false))
    }
    useEffect(() => loadExample(), [])

    return (
        <Box sx={sx}>
            <SpaceBetween>
                <Typography variant="h2">Preview</Typography>
                <IconButton onClick={loadExample}>
                    <ShuffleIcon/>
                </IconButton>
            </SpaceBetween>

            <Box key={row?.id}>
                <Box sx={{maxHeight: 640, overflowY: "auto", mt: 2}}>
                    {row && children}
                </Box>
                {project.stats.numberOfTrainingRows + project.stats.numberOfValidationRows === 0 &&
                    <InfoAlert>Preview will be shown here once there are rows.</InfoAlert>
                }
                {error && <ErrorMessage error={error} sx={{mt: 2}}/>}
            </Box>
        </Box>
    );
}

export default RandomRowLoader;